/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
import React, { useImperativeHandle, useMemo } from 'react';
import moment from "moment";
import { getLocale, useIntl, useSelector } from 'umi';

import { formatNum, formatPercentNum, exportExcel, upperFirstConcat, formatExeclCommon, formatExeclSharePercent, formatExeclNum, formatExeclNormalPercent, getSystemColor, commonValueFormatter } from '@/pages/dashboard/utils/utils';
import { momentFormat } from '@/pages/dashboard/utils/_config/filtersTimeFormat';
import { COLOR_ARR, LANGUAGE_EN } from '@/pages/dashboard/_config/constant';
import { headerText, percentMetricsList, unitMetricsList } from '../constant';
import { getEchartTooltipText } from "@/pages/dashboard/components/EchartsBubble";
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { useMapData, useSelectorMap, useWeekDay } from '@//pages/dashboard/utils/customHook';
import PieChart from '../../Chart/components/PieChart';
import BarChart from '../../Chart/components/BarChart';
import LineChart from '../../Chart/components/LineChart';
import { xAxisHighLight } from '../../Chart/_config/plug';
import StairsChart from '../../Chart/components/StairsChart';
import getSystemLegend from './utils';
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';
import { yAxisFormat } from '../../Chart/_config/utils';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';
import MapEchart from '../../MapEchart';
import { metricsNameText } from './_constant';
import countries from "@/pages/dashboard/components/MapEchart/_config/countries.json";
import { getCustomValueColumnTooltip, getPieTooltip } from '../../EchartsTooltip/utils';
import { selectValByCondition } from '@home/utils/common';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';



// 本来图标列会封装在这个组件中，但是因为要兼容重构的样式和结构，所以图标列的展示和逻辑处理（包括下载的触发）放在上层组件中了
const CountryTabChartsItemCom = (props: any, ref: any) => {
  const {
    data, regionDataType, isZero, loading, isUserQuota, isError, timeType, timeRange, type, isAllUpper, unit = '', gameCode, morePie, title,
    barChartLabelFormatRule,
    activeIndex = 0,
    mapData,
    eyesConfig,
    responeseValueName = 'value',
    barChartType = 'stackChart',
    chartTooltipsConfig,
    customChartOptions,
    mapTooltipName = '',
    comConfig = {
      isHaveBar: true,
      isHaveLine: true,
      isHavePie: true,
      isHaveMap: false,
      isHaveShare: true,
      isHaveDiscount: false,
      isHaveStackLine: false,
    } ,
    extraColumn,
    tabOption
  } = props;

  const PUBLICHEIGHT = 440;
  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    downloadDataFunc
  }));
  const { selector, dataFrame } = useSelector((state: any) => {
    return {
      selector: state?.dashboardSetting?.selector ?? {},
      dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
    };
  });
  const { customBarOptions } = customChartOptions || {};
  const { getSelectorText, getFilterItemText } = useSelectorMap();
  const newRegionType = regionDataType === 'network_type' ? 'network' : regionDataType;
  // pc游戏系统来源图标和图例特殊处理判断
  const isPcSystem = regionDataType === 'os' && dataFrame === 'pc';
  const { isHaveBar, isHaveLine, isHavePie, isHaveMap, isHaveShare, isHaveDiscount, isHaveStackLine } = comConfig;
  // const haveNoLineOrBarChart = !isHaveBar && !isHaveLine && !isHaveDiscount;
  const [barLineChartData = [], pieChartData = []] = data || {};
  const locale = getLocale();
  const hasMonth = timeType === 'Month';
  const metrics = barLineChartData?.[0]?.metrics || '';
  // others显示逻辑
  const hasOthersValue = pieChartData?.find((item: { name: string; }) => item?.name === 'Others')?.value !== '';
  const legendDataList = ((barLineChartData?.[0]?.list?.length >= 11 || hasOthersValue) ? barLineChartData?.[0]?.list : barLineChartData?.[0]?.list?.filter((v: { full_crz_name: string; }) => v?.full_crz_name !== 'Others')) || [];
  const legendData = useMapData(legendDataList, 'full_crz_name', [barLineChartData]).map((v: any) => getSelectorText(newRegionType, v));
  const showIconFlag = legendData?.length > 0;
  const { getWeekDayStr, getWeekDay } = useWeekDay();
  const xAxisData = barLineChartData?.map((item: { date_ymd: any; }) => item?.date_ymd);
  const { formatMessage } = useIntl();
  const dataValueItemArr: any[] = [];
  const dataShareItemArr: any[] = [];
  const dataDiscountItemArr: any[] = [];
  const { tooltipsName, tooltipsType, tooltipsDecimal, tooltipsPercentDecimals } = chartTooltipsConfig || {};
  // 饼图数据
  const dataPieArr = useMemo(() =>
    pieChartData?.map((item: { [x: string]: any; full_name: any; }) => {
      const legendName = (item.full_name)?.replace(/\s+/g, '').toLowerCase();
      return {
        value: item?.[responeseValueName],
        // name: item.full_name,
        name: getFilterItemText(morePie ? newRegionType : 'country', item?.name, item?.full_name),
        itemStyle: {
          color: isPcSystem ? getSystemColor(legendName) : null,
        },
      };
    }) || [],
  [pieChartData, locale]
  );

  // 饼图图例
  const pieLegendDataList = pieChartData?.length >= 11 ? pieChartData : pieChartData?.filter((v: { full_name: string; value: string; }) => !(v?.full_name === 'Others' && v?.value === ''));
  const legendPieData = useMapData(pieLegendDataList, 'full_name', [pieChartData]).map((v: any) => getSelectorText(newRegionType, v));

  const { isHaveEyes, isShowEyes } = eyesConfig || {};
  // 扁平化数据展示浮窗
  const shareData = useMemo(() => {
    const shareData = {};
    barLineChartData?.forEach((item: { list: any[]; date_ymd: any; }) => {
      item?.list?.forEach((e: { crz_name: string; full_crz_name: string; share: number; }) => {
        // @ts-ignore
        shareData[getFilterItemText(newRegionType, e.crz_name, e.full_crz_name) + item?.date_ymd] = formatPercentNum(e.share, 1);
      });
    });
    return shareData;
  }, [barLineChartData, locale]);

  const discountData = useMemo(() => {
    if (isHaveDiscount) {
      const discountData = {};
      barLineChartData?.forEach((item: { list: any[]; date_ymd: any; }) => {
        item?.list?.forEach((e: { crz_name: string; full_crz_name: string; discount: number; }) => {
          // @ts-ignore
          discountData[getFilterItemText(newRegionType, e.crz_name, e.full_crz_name) + item?.date_ymd] = formatPercentNum(e.discount, 1);
        });
      });
      return discountData;
    }
    return [];
  }, [barLineChartData, isHaveDiscount, locale]);

  // 指标值
  const dataValueArr = useMemo(() => {
    for (let i = 0;i < barLineChartData?.length;i++) {
      const valueArr: string[] = barLineChartData[i]?.list?.map((item: { value: any; }) => item.value);
      const shareArr: string[] = barLineChartData[i]?.list?.map((item: { share: any; }) => item.share);
      const discountArr: string[] = barLineChartData[i]?.list?.map((item: { discount: any; }) => item.discount);
      dataValueItemArr?.push(valueArr);
      dataShareItemArr?.push(shareArr);
      dataDiscountItemArr?.push(discountArr);
    }
    return dataValueItemArr?.[0]?.map((col: any, i: string | number) => {
      return dataValueItemArr.map((row) => {
        return row[i];
      });
    }) || [];
  }, [dataValueItemArr, barLineChartData]);

  const dataDiscountArr = useMemo(() => {
    return dataDiscountItemArr?.[0]?.map((col: any, i: string | number) => {
      return dataDiscountItemArr.map((row) => {
        return row[i];
      });
    }) || [];
  }, [dataDiscountItemArr]);
  // 柱状图serious
  const barSeries = dataValueArr.length > 0 ?
    dataValueArr?.map((item: any, index: string | number) => {
      return {
        name: legendData[index],
        type: "bar",
        stack: isHaveEyes ? 'Total' : barChartType === "stackChart" ? "overviewBar" : index,
        barCategoryGap: "50%",
        data: item,
        cursor: "pointer",
        // @ts-ignore
        dataShare: dataShareItemArr[index],
        itemStyle: {
          color: isPcSystem ? getSystemColor(legendData[index]) : null,
        },
      };
    })?.filter((v: { name: any; }) => v?.name) : [];

  const lineSeries = dataValueArr.length > 0
    ? dataValueArr?.map((item: any, index: string | number) => {
      const legendName = (legendData[index])?.replace(/\s+/g, '').toLowerCase();
      return {
        name: legendData[index],
        type: "line",
        symbol: "circle",
        emphasis: {
          focus: "none",
        },
        data: item,
        // @ts-ignore
        dataShare: dataShareItemArr[index],
        itemStyle: {
          color: isPcSystem ? getSystemColor(legendData[index]) : null,
        },
      };
    })?.filter((v: { name: any; }) => v?.name)
    : [];

  // 堆积折线图 series
  const stackLineSeries = dataValueArr.length > 0
    ? dataValueArr?.map((item: any, index: string | number) => {
      return {
        name: legendData[index],
        type: "line",
        stack: 'Total',
        symbol: "circle",
        areaStyle: {
          opacity: 0.2
        },
        // smooth: true,
        emphasis: {
          focus: "series",
        },
        data: item,
        // @ts-ignore
        dataShare: dataShareItemArr[index],
        itemStyle: {
          color: isPcSystem ? getSystemColor(legendData[index]) : null,
        },
      };
    })?.filter((v: { name: any; }) => v?.name)
    : [];

  const stairsSeries = dataValueArr.length > 0
    ? dataDiscountArr?.map((item: any, index: string | number) => {
      return {
        name: legendData[index],
        step: true,
        type: "line",
        symbol: "circle",
        emphasis: {
          focus: "none",
        },
        data: item,
        xAxisIndex: 1,
        yAxisIndex: 1,
        itemStyle: {
          color: isPcSystem ? getSystemColor(legendData[index]) : null,
        },
      };
    })?.filter((v: { name: any; }) => v?.name)
    : [];

  /* Chart */

  const barName = (isAllUpper ? metrics.toUpperCase() : upperFirstConcat(metrics)) + unit;
  // @ts-ignore
  const barmetricsName = metricsNameText[barName] ? formatMessage({ id: metricsNameText[barName] }, unitMetricsList?.includes(barName) ? { unit: getMonetUnit() } : {}) : formatMessage({ id: 'engagement_active_activeUsers_day_au_title' });
  // const tooltipsType
  const chartConfig = {
    pieFormatter: (param: any) => {
      const { name, value, color, data: { total } } = param;
      const timeTypeObj: any = {
        Day: 'YYYY-MM-DD',
        Week: 'YYYY-MM-DD',
        Month: 'YYYY-MM'
      };
      const starTime = timeRange?.[0];
      const endTime = timeRange?.[1];
      const pieTitle = `${getWeekDayStr(moment(starTime).format(timeTypeObj[timeType]), timeType)}~${getWeekDayStr(moment(endTime).format(timeTypeObj[timeType]), timeType)}`;
      const metricValue = commonValueFormatter(tooltipsType, value, tooltipsDecimal);

      if (regionDataType === 'os') {
        const newParam = { ...param, value: chartTooltipsConfig ? metricValue : percentMetricsList?.includes(barName) ? formatPercentNum(value, 2) : formatNum(value, false, isUserQuota) };
        // 走新浮窗处理
        return getPieTooltip({
          param: newParam, options: {
            title: pieTitle,
            isPlatform: true,
            valueFormatRule: '',
          }
        });
      }

      return getEchartTooltipText({
        title: pieTitle,
        metricsName: '',
        ratioName: '',
        hasRatio: true,
        data: [{
          name,
          icon: regionDataType === 'os' ? getSystemFlag(name) : '',
          metricsNum: chartTooltipsConfig ? metricValue : percentMetricsList?.includes(barName) ? formatPercentNum(value, 2) : formatNum(value, false, isUserQuota),
          ratioNum: formatPercentNum(value / total, 1),
          color,
          customColor: isPcSystem,
        }],
        isSort: true,
      });
    },
    barFormatter: (param: any[]) => {
      // 走新浮窗处理
      return getCustomValueColumnTooltip({
        params: param, options: {
          hasSum: false,
          hasShare: isHaveShare,
          valueNameCn: tooltipsName ? tooltipsName : barmetricsName,
          valueNameEn: tooltipsName ? tooltipsName : barmetricsName,
          isEn: locale === LANGUAGE_EN,
          isPlatform: regionDataType === 'os',
          valueFormatRule: '',
          formatFirstThText: (date) => {
            return getWeekDayStr(moment(date).format(hasMonth ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType);
          }
        }
      }, (value) => {
        return percentMetricsList?.includes(barName) ? formatPercentNum(value, 2) : formatNum(isZero ? +value : value, false, isUserQuota);
      });
      // const title = getWeekDayStr(moment(param?.[0]?.axisValue).format(hasMonth ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType);
      // return getEchartTooltipText({
      //   title,
      //   metricsName: tooltipsName ? tooltipsName : barmetricsName,
      //   ratioName: formatMessage({ id: 'common_share' }),
      //   hasRatio: isHaveShare,
      //   data: param.map(({ seriesName, value, color, axisValue }: any) => ({
      //     name: seriesName,
      //     icon: regionDataType === 'os' ? getSystemFlag(seriesName) : '',
      //     metricsNum: percentMetricsList?.includes(barName) ? formatPercentNum(value, 2) : formatNum(isZero ? +value : value, false, isUserQuota),
      //     // @ts-ignore
      //     ratioNum: shareData[seriesName + axisValue],
      //     color,
      //     // customColor: isPcSystem,
      //   })),
      //   isSort: true,
      // });
    },
    stairsFormatter: (param: any[]) => {
      const newParams = param?.filter(v => v?.axisIndex === 0);
      return getEchartTooltipText({
        title: hasMonth ? momentFormat(param[0].axisValue, 'YYYY-MM') : param[0].axisValue,
        metricsName: tooltipsName ? tooltipsName : barmetricsName,
        ratioName: formatMessage({ id: 'common_discount' }),
        hasRatio: isHaveDiscount,
        data: newParams.map(({ seriesName, value, color, axisValue }) => ({
          name: seriesName,
          icon: regionDataType === 'os' ? getSystemFlag(seriesName) : '',
          metricsNum: percentMetricsList?.includes(barName) ? formatPercentNum(value, 2) : formatNum(isZero ? +value : value, false, isUserQuota),
          // @ts-ignore
          ratioNum: discountData[seriesName + axisValue],
          color,
          customColor: isPcSystem,
        })),
        isSort: true,
      });
    },
    setOtherConfigFunc: (opt: any) => {
      opt.xAxis[0].axisLabel.formatter = function (value: string) {
        return hasMonth ? `${moment(value).format('YYYY-MM')}` : `${moment(value).format('MM-DD')}`;
      };
      if (percentMetricsList?.includes(barName)) {
        opt.yAxis.axisLabel.formatter = (value: number) => {
          return yAxisFormat(value, true, 2, true);
        };
      }
      opt = xAxisHighLight(opt, {
        formatter: (params: any) => {
          // return params.value ? hasMonth ? params.value?.slice(0, 7): params.value?.slice(5, 10) : ''
          const value = params?.value;
          return value ? moment(value).format(hasMonth ? 'YYYY-MM' : 'MM-DD') : '';
        }
      });

      // pc console游戏os来源legend显示图标
      if (regionDataType === 'os') {
        getSystemLegend(opt, selector);
        opt.legend.bottom = -4;
      }
      return opt;
    },
    pieSetOtherConfigFunc: (opt: any) => {
      // pc console游戏os来源legend显示图标
      if (regionDataType === 'os') {
        getSystemLegend(opt, selector);
      }
      if (isPcSystem) {
        opt.series[0].data = opt.series[0].data?.map((item: any) => {
          return {
            ...item,
            // 注意这里的值不能等于""空字符串，否则饼图会变黑色
            itemStyle: { color: getSystemColor(item?.name || '') || undefined }
          };
        });
        // 取消饼图默认颜色
        opt.series[0].itemStyle = undefined;
      }
      return opt;
    }
  };

  const worldData = useMemo(() => {
    return mapData?.map((item: any) => {
      return {
        ...item,
        name: getFilterItemText(newRegionType, item?.name, item?.full_name)
      };
    });
  }, [mapData, locale]);

  const mapColorV = useMemo(() => {
    const maxValue = mapData?.[0]?.value;
    const interval: number = Math.ceil(maxValue / 6);
    const num = interval?.toString()?.length > 2 ? (10 ** (interval?.toString()?.length - 1)) : 1;
    const newInterval = Math.ceil(interval / num) * num;
    // 计算出色值对应的value
    return interval ? Array.from({ length: 7 }).map((_: unknown, i: number) => (i * newInterval)) : [];
  }, [mapData, locale]);

  // 浮窗展示
  const mapFormatterFunc = (param: any) => {
    const { data, name, value, color, componentSubType } = param;
    // 地图标记的浮窗隐藏掉
    if (!componentSubType) return;
    if (!data) return null;
    const metricsName = tooltipsName ? tooltipsName : barmetricsName;
    return getEchartTooltipText({
      title: formatMessage({ id: `overview_area_tab_${regionDataType}` }),
      metricsName: mapTooltipName ? mapTooltipName : metricsName,
      ratioName: formatMessage({ id: 'overview_area_active_table_header3' }),
      hasRatio: true,
      data: [{
        name: getSelectorText(regionDataType, name),
        icon: regionDataType === 'os' ? getSystemFlag(name) : '',
        metricsNum: formatNum(isZero ? +value : value, false, isUserQuota),
        ratioNum: formatPercentNum(parseFloat(data?.share_of_all?.trim()), 1),
        color,
      }]
    });
  };
  const tabsChartArr = useMemo(() => {
    const { customLegendData = [], customXAxisData = [], customBarSeries = [], customBarFormatter, customBarSetOther } = customBarOptions || {};
    const tabsChart = [
      {
        id: "chart1",
        show: isHaveBar,
        component: (
          <BarChart
            isStackBar={isHaveEyes ? isShowEyes : false}
            key={locale}
            height={PUBLICHEIGHT}
            colorArr={COLOR_ARR}
            legendData={customLegendData?.length > 0 ? customLegendData : legendData}
            xAxisData={customXAxisData?.length > 0 ? customXAxisData : xAxisData}
            series={customBarSeries?.length > 0 ? customBarSeries : barSeries}
            barChartLabelFormatRule={barChartLabelFormatRule}
            formatterFunc={customBarFormatter?.length > 0 ? customBarFormatter : chartConfig.barFormatter}
            setOtherConfigFunc={customBarSetOther?.length > 0 ? (opt: any) => {
              return customBarSetOther(opt, isShowEyes);
            } : chartConfig.setOtherConfigFunc}
          />
        ),
        disabled: false,
      },
      {
        id: "chart2",
        show: isHaveLine,
        component: (
          !isHaveDiscount ?
            <LineChart
              height={PUBLICHEIGHT}
              key={locale}
              colorArr={COLOR_ARR}
              legendData={legendData}
              xAxisData={xAxisData}
              series={lineSeries}
              formatterFunc={chartConfig?.barFormatter}
              setOtherConfigFunc={chartConfig?.setOtherConfigFunc}
            /> : <StairsChart
              height={PUBLICHEIGHT}
              colorArr={COLOR_ARR}
              legendData={legendData}
              key={locale}
              xAxisData={xAxisData}
              series={[...lineSeries, ...stairsSeries]}
              formatterFunc={chartConfig.stairsFormatter}
              setOtherConfigFunc={chartConfig.setOtherConfigFunc}
            />
        ),
      },
      {
        id: "chart3",
        show: isHaveStackLine,
        component: (
          <LineChart
            height={PUBLICHEIGHT}
            key={locale}
            colorArr={COLOR_ARR}
            legendData={legendData}
            xAxisData={xAxisData}
            series={stackLineSeries}
            formatterFunc={chartConfig?.barFormatter}
            setOtherConfigFunc={chartConfig?.setOtherConfigFunc}
          />
        ),
      },
      {
        id: "chart4",
        show: isHavePie,
        component: (
          <PieChart
            loading={false}
            isSort={true}
            isShowTop5Lines={true}
            key={locale}
            chartData={dataPieArr}
            height={PUBLICHEIGHT}
            colorArr={COLOR_ARR}
            legendData={legendPieData}
            formatterFunc={chartConfig.pieFormatter}
            setOtherConfigFunc={chartConfig?.pieSetOtherConfigFunc}
          // if(isSort) {
          //   // 本期只是做overview的效果给产品看，后面如果全局修改则删除，直接写在配置中
          //   opts.series[0].startAngle =90;
          //   opts.series[0].clockwise =false;
          // }
          />
        ),
      },
      {
        id: "chart5",
        show: isHaveMap,
        component: (
          <div key={mapTooltipName}>
            <MapEchart
              height={PUBLICHEIGHT}
              isUnit={type === "Revenue"}
              data={worldData}
              key={locale}
              mapColorV={mapColorV}
              formatterFunc={mapFormatterFunc}
              setOtherConfigFunc={(opt: any) => {
                try {
                  const markData: { name: string; coord: [number, number]; }[] = [];
                  for (let i = 0;i < 5;i++) {
                    const item = worldData?.[i];
                    // 这个判断可以过滤掉 worldData[i]为空, name为其他, 以及找不到coord的情况
                    // @ts-ignore
                    const coord = countries[locale]?.[item?.name];
                    coord && markData.push({ name: item?.name, coord });
                  }
                  const specialCountries = [
                    'United States', '美国',
                    'Brazil', '巴西',
                    'Canada', '加拿大',
                    // 在这里添加其他国家的中英名称
                  ];

                  opt.series[0].markPoint = {
                    symbol: 'path://M10.031 14H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h19a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H16.97L13.5 18.445 10.031 14Z',
                    symbolSize: [27, 18.44],
                    animation: false,
                    silent: true,
                    data: markData.map((item, index) => ({
                      name: item.name,
                      coord: item.coord,
                      itemStyle: {
                        color: '#29B569FF',
                      },
                      symbolOffset: [0, specialCountries.includes(item.name) ? -20 : -10],
                      label: {
                        show: true,
                        formatter: `Top ${index + 1}`,
                        position: 'inside',
                        color: 'white',
                        fontSize: 8,
                        fontWeight: 'bold',
                        fontStyle: 'italic',
                        width: 19,
                        height: 10,
                        offset: [0, -2],
                      },
                    })),
                  };
                  if (regionDataType === 'os') {
                    getSystemLegend(opt, selector);
                  }
                } catch (e) {
                  console.log("Overview页面设置地图前5个国家标注错误: ", e);
                }
                return opt;
              }}
            />
          </div>
        ),
      }
    ];
    return tabsChart?.filter((item) => item?.show);
  }, [props, customBarOptions, locale, mapTooltipName]);

  const downData = useMemo(() => {
    // @ts-ignore
    const metricName = formatMessage({ id: metricsNameText[barName] ? metricsNameText[barName] : 'engagement_active_activeUsers_day_au_title' }, unitMetricsList?.includes(barName) ? { unit: getMonetUnit() } : {}) + unit || '';
    const selectedExtraColumn = extraColumn?.find((item: { tabKey: string | any[]; }) => item.tabKey.includes(tabOption));
    const formatRule = selectedExtraColumn?.dataFormats?.[tabOption] || selectedExtraColumn?.dataFormat;
    
    // tooltipsName ? tooltipsName : barmetricsName
    const dataArr: any = [
      isHaveShare ? {
        A: "Date",
        B: formatMessage({ id: 'common_day_of_week' }),
        C: upperFirstConcat(regionDataType),
        D: tooltipsName ? tooltipsName : metricName,
        E: formatMessage({ id: 'common_share' }),
        ...(selectedExtraColumn && { F: selectValByCondition(locale === LANGUAGE_EN, selectedExtraColumn.headerEN, selectedExtraColumn.headerCN) }),
      } : isHaveDiscount ? {
        A: "Date",
        B: formatMessage({ id: 'common_day_of_week' }),
        C: upperFirstConcat(regionDataType),
        D: tooltipsName ? tooltipsName : metricName,
        E: formatMessage({ id: 'common_discount' }),
      } : {
        A: "Date",
        B: formatMessage({ id: 'common_day_of_week' }),
        C: upperFirstConcat(regionDataType),
        D: tooltipsName ? tooltipsName : metricName,
      }
    ];
    barLineChartData.forEach((item: { list: any[]; date_ymd: any; }) => {
      item.list.forEach((e: { value: string | number | null; full_crz_name: string; share: any; discount: any;[key: string]: any;}) => {
        // @ts-ignore
        const metricValue = percentMetricsList?.includes(barName) ? formatExeclNormalPercent(e.value) : isUserQuota ? formatExeclNum(isZero ? +e.value : e.value) : formatExeclCommon(isZero ? +e.value : e.value);
        const extraColumnData = selectedExtraColumn 
          ? dataFormat({value: e?.[selectedExtraColumn?.columnKey], formatRule})
          : undefined;
        // others没有值过滤逻辑
        if (!hasOthersValue && e?.full_crz_name === 'Others') return;
        dataArr.push(isHaveShare ? {
          A: hasMonth ? momentFormat(item?.date_ymd, 'YYYY-MM') : item?.date_ymd,
          B: e.full_crz_name,
          C: metricValue,
          D: formatExeclSharePercent(e.share),
          ...(selectedExtraColumn && { F: extraColumnData }),
        } : isHaveDiscount ? {
          A: hasMonth ? momentFormat(item?.date_ymd, 'YYYY-MM') : item?.date_ymd,
          B: e.full_crz_name,
          C: metricValue,
          D: formatExeclSharePercent(e.discount),
        } : {
          A: hasMonth ? momentFormat(item?.date_ymd, 'YYYY-MM') : item?.date_ymd,
          B: e.full_crz_name,
          C: metricValue,
        });
      });
    });
    return dataArr;
  }, [barLineChartData, locale]);

  // 导出excel
  const downloadDataFunc = () => {
    // @ts-ignore
    const ckey = metricsNameText[downData[0].C] ? formatMessage({ id: metricsNameText[downData[0].C] }, unitMetricsList?.includes(downData[0].C) ? { unit: getMonetUnit() } : {}) : downData[0].C;
    const newDownData = downData.map((item: { A: any; B: any; C: any; D: any; }, index: number) => {
      return index === 0
        ? {
          ...item,
          A: formatMessage({ id: 'ua_Date' }),
          // @ts-ignore
          B: headerText[downData[0].B] ? formatMessage({ id: headerText[downData[0].B] }, unitMetricsList?.includes(downData[0].B) ? { unit: getMonetUnit() } : {}) : downData[0].B,
          C: ckey,
        }
        : {
          ...item,
          B: getWeekDay(item.A),
          C: getSelectorText(newRegionType, item.B, true),
          D: item?.C,
          E: item?.D,
        };
    });

    const noTop = ['network_type', 'os', 'lang'];
    if (hasMonth) {
      //  月粒度删除周的列
      newDownData.map((item: { B: any; }) => { delete item.B });
    }
    // @ts-ignore
    exportExcel(title, [...newDownData]);
  };
  // 新增dataPieArr?.length === 0主要是因为，夜莺daily pcu/dau/ dau/wau dau/mau,只有饼图，后端不会返回折线图和柱状图
  // 但是饼图用的是表格的数据，所以这里添加新增dataPieArr的长度判断
  const isNodata = xAxisData?.length === 0 && legendData?.length === 0 && dataPieArr?.length === 0;
  return <>
    <Abnormal isLoading={loading} isError={isError} isNoData={isNodata} component={tabsChartArr?.[activeIndex]?.component} style={{ height: PUBLICHEIGHT }} />
  </>;
};



const CountryTabChartsItem = React.forwardRef(CountryTabChartsItemCom);

export default CountryTabChartsItem;
